export default __webpack_public_path__ + "static/6-e53328d3970b94aa98e474dc23862c2e.png";